import React, { Component } from 'react';
import moment from 'moment';

export default class saleLimitDate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limitDateSales: '',
      color: '',
    };

    this.handleStorageChange = this.handleStorageChange.bind(this);
  }

  componentDidMount() {
    window.addEventListener('storage', this.handleStorageChange);
    this.renderLimitDate();
  }

  componentWillUnmount() {
    window.removeEventListener('storage', this.handleStorageChange);
  }

  handleStorageChange(event) {
    if (event.key === 'listSalesNotifications') {
      this.renderLimitDate();
    }
  }

  renderLimitDate() {
    const { id, salesInformation } = this.props.data;
    let color = '';

    if (salesInformation && salesInformation.limitDate) {
      let date = moment(salesInformation.limitDate).utc().format('DD-MM-YYYY');

      if (localStorage.getItem('listSalesNotifications')) {
        let notifications =
          JSON.parse(localStorage.getItem('listSalesNotifications')) || [];

        const existingNotificationIndex = notifications.findIndex(
          (item) => item.id === id
        );

        if (existingNotificationIndex !== -1) {
          const labelDate =
            notifications[existingNotificationIndex].label.split(' - ');
          date = moment(labelDate[0], 'DD/MM/YYYY').utc().format('DD-MM-YYYY');

          if (notifications[existingNotificationIndex].color === 'Red') {
            color = '#FF0000';
          } else if (
            notifications[existingNotificationIndex].color === 'Yellow'
          ) {
            color = '#ffff00';
          }
        }
      }

      this.setState({ limitDateSales: date, color });
    }
  }

  render() {
    const { limitDateSales, color } = this.state;

    return (
      <div>
        {color !== '' && <i className="fa fa-circle" style={{ color }}></i>}
        {limitDateSales}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CellRenderer/saleLimitDate.jsx